import React, { useState } from "react";
import { useParams } from "react-router-dom";
import Iframe from "react-iframe";
import Axios from "axios";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography
} from "@mui/material";
import LoadingSpinner from "../Cms/Layout/Spinner";

import "./Catalog.css";

async function getData(url) {
  try {
    let result = await Axios.get(
      `${process.env.REACT_APP_BACKEND_DOMAIN_API}/web_catalogs/friendly_url/${url}`,
      {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_X_API_KEY,
        },
      }
    );
    return result.data;
  } catch (error) {
    console.log(`bigc-online-catalogs: ${error}`);
  }
}

export default function Catalog() {
  const { pdfFile } = useParams();
  let couponItems = [] ;


  const [sourceFile, setSourceFile] = React.useState("");
  const [responseStatus,setResponseStatus] = React.useState('');

  React.useEffect(async () => {
    //check url
    const getCatalog = await getData(pdfFile);

    //console.log(getCatalog);
    if (getCatalog.data) {
      setSourceFile(getCatalog.data.source_file);
      setResponseStatus(getCatalog.status);
    }
    else{
      setResponseStatus("warning");
    }
  }, [pdfFile]);

//console.log(responseStatus);

  if (responseStatus === "success") {

const baseUrl = "https://storage.googleapis.com/public-image-bigc-line";

const trimmedUrl = sourceFile.replace(baseUrl, "");
    return (<Iframe
          url={`/PDFFlip/view.html?v=1&file=` + trimmedUrl}
          position="absolute"
          width="100%"
          id="myId"
          className="myClassname"
          height="100%"
          styles={{ border: "none" }}
        />
        );
  }else if (responseStatus === "warning"){
    return(
      <><Grid item sm={12} xs={12}>
      <Card sx={{ height: "100%", boxShadow: 0, borderRadius: 2 }}>
        <CardContent>
          <Box
            sx={{ display: "flex", justifyContent: "center", width: "100%" }}
          >
            <Box
              component="img"
              src="/img/404.png"
              sx={{ width: 300,mt:10}}
            />
          </Box>
        </CardContent>
      </Card>
    </Grid></>
    );
  }else {
    return (
      <Box sx={{ m: '0 auto', width: '100px', pt: 10 }} >
        <LoadingSpinner/>
      </Box>
    );
  }

  return (
    {couponItems}
    
  );
}
